import Vue from 'vue';
import Inputmask from 'inputmask';
import './assets/js/InputmaskAliases';
import {disablePageScroll, enablePageScroll} from 'scroll-lock';

export default function registerVueDirectives() {
    Vue.directive('class-toggler', {
        inserted(el, {modifiers: {parent, closest, prevent}, arg, value}) {
            el.clickCallback = (e) => {
                // v-class-toggler.prevent="'some-class'"
                if (prevent) {
                    e.preventDefault();
                }
                let target;
                switch (true) {
                    // v-class-toggler.parent="'some-class'"
                    case parent:
                        target = el.parentNode;
                        break;
                    // v-class-toggler:closest-el-class.closest="'some-class'"
                    case closest:
                        target = arg ? el.closest(`.${arg}`) : el;
                        break;
                    // v-class-toggler="'some-class'"
                    default:
                        target = el;
                }
                if (!target) {
                    return;
                }

                target.classList.toggle(value);
            };
            el.addEventListener('click', el.clickCallback);
        },
        unbind(el) {
            el.addEventListener('click', el.clickCallback);
        },
    });
    Vue.directive('nav-toggle', {
        inserted(el, {modifiers: {prevent}, value}) {
            el.clickCallback = (e) => {
                const body = document.body;
                const currentMenuCls = 'nav-opened';
                const otherMenuCls = 'header-menu-extra-opened';
                if (prevent) {
                    e.preventDefault();
                }
                if (body.classList.contains(currentMenuCls)) {
                    enablePageScroll();
                    body.classList.remove(currentMenuCls);
                } else {
                    if (value != 'nav-item') {
                        if (body.classList.contains(otherMenuCls)) {
                            body.classList.remove(otherMenuCls);
                        }
                        disablePageScroll();
                        body.classList.add(currentMenuCls);
                    }
                }
            };
            el.addEventListener('click', el.clickCallback);
        },
        unbind(el) {
            el.removeEventListener('click', el.clickCallback);
        },
    });
    Vue.directive('menu-extra-toggle', {
        inserted(el, {modifiers: {prevent}}) {
            el.clickCallback = (e) => {
                const body = document.body;
                const currentMenuCls = 'header-menu-extra-opened';
                const otherMenuCls = 'nav-opened';
                if (prevent) {
                    e.preventDefault();
                }
                if (body.classList.contains(currentMenuCls)) {
                    enablePageScroll();
                    body.classList.remove(currentMenuCls);
                } else {
                    if (body.classList.contains(otherMenuCls)) {
                        body.classList.remove(otherMenuCls);
                    }
                    disablePageScroll();
                    body.classList.add(currentMenuCls);
                }
            };
            el.addEventListener('click', el.clickCallback);
        },
        unbind(el) {
            el.removeEventListener('click', el.clickCallback);
        },
    });
    Vue.directive('open-popup', {
        bind(el, binding, vnode) {
            el.clickCallback = (e) => {
                e.preventDefault();
                vnode.context.$root.popup[binding.arg] = true;
            };
            el.addEventListener('click', el.clickCallback);
        },
        unbind(el) {
            el.addEventListener('click', el.clickCallback);
        },
    });
    Vue.directive('close-popup', {
        bind(el, binding, vnode) {
            el.clickCallback = () => {
                Object.keys(vnode.context.$root.popup).map(key => (vnode.context.$root.popup[key] = false))
            };
            el.addEventListener('click', el.clickCallback);
        },
        unbind(el) {
            el.addEventListener('click', el.clickCallback);
        },
    });
    Vue.directive('focus', {
        bind: function (el) {
            const className = 'focused';
            const onFocus = () => {
                el.parentNode.classList.add(className);
            };
            const onChange = () => {
                if (!el.value) {
                    el.parentNode.classList.remove(className);
                    if (el.required) {
                        el.parentNode.classList.add('error');
                    }
                } else {
                    if (el.required) {
                        el.parentNode.classList.remove('error');
                    }
                }
            };

            el.addEventListener('click', onFocus);
            el.addEventListener('focus', onFocus);
            el.addEventListener('blur', onChange);
            el.addEventListener('change', onChange);
        },
    });
    Vue.directive('sticky-header', {
        inserted: function (el) {
            const className = '_fixed',
                offsetElHeight = document.querySelector('.header__top').clientHeight;

            el.scroll = function () {
                if (window.pageYOffset > offsetElHeight) {
                    el.classList.add(className);
                    el.parentElement.style.paddingBottom = el.clientHeight + 'px';
                } else {
                    el.classList.remove(className);
                    el.parentElement.style.paddingBottom = 0;
                }
            };

            el.scroll();
            window.addEventListener('scroll', el.scroll);
        },
        unbind: function (el) {
            window.removeEventListener('scroll', el.scroll);
        },
    });
    Vue.directive('sticky-order', {
        inserted: function (el) {

            el.scroll = function () {
                let footerTop = document.getElementById('footer').getBoundingClientRect().top + document.documentElement.scrollTop - window.innerHeight;
                if ((document.documentElement.scrollTop) > footerTop) {
                    el.classList.add('abs');
                } else {
                    el.classList.remove('abs');
                }
            };

            el.scroll();
            window.addEventListener('scroll', el.scroll);
        },
        unbind: function (el) {
            window.removeEventListener('scroll', el.scroll);
        },
    });
    Vue.directive('input-mask', {
        bind: function (el, binding) {
            Inputmask(binding.value).mask(el);
        },
    });
    Vue.directive('mask', {
        bind(el, binding) {
            Inputmask(binding.value).mask(el);
        },
        unbind: function(el) {
            Inputmask.remove(el);
        }
    });
}

